<template>
  <div class="athletes_photo" style="width:1050px">
    <header>
      <h1>{{details.matchName}}</h1>
      <h2>{{userInfo.schoolName}}大学生参赛运动员</h2>
    </header>
    <template v-if="getShowNum > 0">
      <template v-for="item in getShowNum">
        <div :key="item">
          <div class="top" style="width:100%;display:flex">
            <div
              :style="{borderRight:(index+1) == 10 ?'none':'1px solid #999'}"
              style="width:10%;"
              v-for="(temp,index) in details.swimAthleteList.slice((item - 1) * 10,item * 10)"
              :key="index + '_' + item"
            >
              <div style="display:flex;justify-content:center;align-items:center;">
                <section style="padding:10px;">
                  <img :src="temp.headImage" style="width:100px;height:120px;" alt />
                </section>
              </div>
            </div>
          </div>
          <div class="bottom" style="width:100%;display:flex">
            <div
              :style="{borderRight:(index+1) == 10 ?'none':'1px solid #999',borderBottom:item === getShowNum?'none':'1px solid #999'}"
              style="width:10%;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;"
              v-for="(temp,index) in details.swimAthleteList.slice((item - 1) * 10,item * 10)"
              :key="index + '-' + item"
            >
              <p style="margin-bottom:10px;font-size:16px;color:#444;display:flex;">
                <span style="max-width:140px;">{{temp.name}}</span>
              </p>
              <p
                style="word-wrap: break-word;word-break: break-all;text-align: center;font-size:14px"
              >{{temp.registerNumber}}</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
        <div style="width:100%;height:200px;display:flex;align-items:center;justify-content:center;font-size:24px">暂无数据</div>
    </template>
    <!-- <main>
      <template v-for="(temp,num) in getShowListNum">
        <div :key="num" style="display:flex">
          <div
            v-for="(item,index) in details.swimAthleteList.slice(num * 5,(num + 1) * 5)"
            :key="num + '_' + index"
            :style="{borderRight:(index + 1) % 5 === 0?'none':'1px solid #999'}"
            style="width:20%;display:flex;flex-direction:column;
            justify-content:center;align-items:center;border-right:1px solid #999"
          >
            <section style="padding:10px;">
              <img :src="item.headImage" style="width:160px;height:200px;" alt />
            </section>
            <section
              :style="{borderBottom:details.swimAthleteList.length < 5?'none':'1px solid #999'}"
              style="width:100%;border-top:1px solid #999;text-align:center;padding:10px 0;height:66px"
            >
              <p style="margin-bottom:10px;font-size:18px;color:#444;">
                <span style="margin-right:16px">{{item.signNumber}}</span>
                <span>{{item.athleteName}}</span>
              </p>
              <p>{{item.registerNumber}}</p>
            </section>
          </div>
        </div>
      </template>
    </main>-->
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
export default {
  props: ["details"],
  data() {
    return {
      userInfo: JSON.parse(getSession("userInfo")) || "",
      athleteList: []
    };
  },
  computed: {
    getShowNum() {
      let num = 0;
      if (
        this.details.swimAthleteList &&
        this.details.swimAthleteList.length < 10 &&
        this.details.swimAthleteList.length > 0
      ) {
        num = 1;
      } else if (
        this.details.swimAthleteList &&
        this.details.swimAthleteList.length >= 10
      ) {
        let length = this.details.swimAthleteList.length;
        if (length / 10 > parseInt(length / 10)) {
          num = parseInt(length / 10) + 1;
        } else {
          num = length / 10;
        }
      }

      return num;
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.athletes_photo {
  width: 100% !important;
  border: 1px solid #999;
  margin-top: 30px;
  > header {
    text-align: center;
    padding: 44px 0;
    color: #444;
    font-weight: 600;
    border-bottom: 1px solid #999;
    > h1 {
      font-size: 24px;
      margin-bottom: 14px;
    }
    > h2 {
      font-size: 22px;
    }
  }
}
</style>